import {
    pathValue as $value
} from '@graphistry/falcor-json-graph';

import { Observable } from '@reactivex/rxjs';
import {
    UPDATE_TIMEBAR_MODE,
    UPDATE_TIMEBAR_ENABLE_TIMESTAMP,
    UPDATE_TIMEBAR_SPEED,
    UPDATE_TIMEBAR_PLAY,
    UPDATE_TIMEBAR_LOOP,
    UPDATE_TIMEBAR_PLAYHEAD_START,
    UPDATE_TIMEBAR_INTERVAL
} from '@graphistry/viz/src/actions/timebar';

export function timebar(action$, store) {
    return Observable.merge(
        updateTimebarMode(action$, store),
        updateTimebarEnableTimestamp(action$, store),
        updateTimebarSpeed(action$, store),
        updateTimebarPlay(action$, store),
        updateTimebarLoop(action$, store),
        updateTimebarPlayheadStart(action$, store),
        updateTimebarInterval(action$, store),
    ).ignoreElements();
}

function updateTimebarMode(action$) {
    return action$
        .ofType(UPDATE_TIMEBAR_MODE)
        .switchMap(({ falcor, value }) => falcor.set($value('timebar.mode', value ?? false)));
}

function updateTimebarEnableTimestamp(action$) {
    return action$
        .ofType(UPDATE_TIMEBAR_ENABLE_TIMESTAMP)
        .switchMap(({ falcor, value }) => falcor.set($value('timebar.enableTimestamp', value ?? false)));
}

function updateTimebarSpeed(action$) {
    return action$
        .ofType(UPDATE_TIMEBAR_SPEED)
        .switchMap(({ falcor, value }) => falcor.set($value('timebar.speed', value)));
}

function updateTimebarPlay(action$) {
    return action$
        .ofType(UPDATE_TIMEBAR_PLAY)
        .switchMap(({ falcor, value }) => falcor.set($value('timebar.play', value ?? false)));
}

function updateTimebarLoop(action$) {
    return action$
        .ofType(UPDATE_TIMEBAR_LOOP)
        .switchMap(({ falcor, value }) => falcor.set($value('timebar.loop', value ?? false)));
}

function updateTimebarPlayheadStart(action$) {
    return action$
        .ofType(UPDATE_TIMEBAR_PLAYHEAD_START)
        .switchMap(({ falcor, value }) => falcor.set($value('timebar.playheadStart', value ?? 0)));
}

function updateTimebarInterval(action$) {
    return action$
        .ofType(UPDATE_TIMEBAR_INTERVAL)
        .switchMap(({ falcor, value }) => falcor.set($value('timebar.interval', value ?? 0)));
}